export enum DoctorTitle {
  Dr = 1,
  SpecialistDr = 2,
  AssocProfDr = 3,
  ProfDr = 4,
  OpDr = 5,
}
